import React from "react";
import { ContainerId } from "@/components/marca/ContainerId";
import { TIPO_EN } from "@/lib/chofer";
import { t } from "@/lib/i18n";
// Fix Q (2026-10-13): encabezado de la carga en la app del chofer: el contenedor siempre visible, en blanco y negrita sobre azul.
export function CabeceraCarga({ carga, nombreChofer }) {
  return (
    <header className="bg-navy border-t-4 border-brand border-b-[3px] border-b-gold" data-testid="chofer-detalle-cabecera">
      <div className="px-4 pt-4 pb-4 max-w-md mx-auto">
        <p className="font-display font-bold text-[12.5px] uppercase tracking-[.12em] text-white">{t("LEONA’S GROUP · DRIVER {nombreChofer}", { nombreChofer })}</p>
        <h1 className="mt-2 text-white leading-none" data-testid="chofer-detalle-contenedor">
          {carga.numero_contenedor ? <ContainerId numero={carga.numero_contenedor} size="xl" className="!text-white [&_span]:!font-bold" digitoLabel={t("check digit")} /> : <span className="font-display font-bold text-[28px]">{carga.load_id || t("Container pending pickup")}</span>}
        </h1>
        <p className="mt-2 text-[13px] font-semibold uppercase tracking-[.06em] text-white" data-testid="chofer-detalle-tipo">
          {TIPO_EN[carga.tipo_operacion] || ""}{carga.tamano ? ` · ${carga.tamano}` : ""}
        </p>
      </div>
    </header>
  );
}
